module.exports = __webpack_public_path__ + "assets/img/wlhyApp.283a164f.png";